// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__qXajV","page":"Footer_page__UZ7M6","more":"Footer_more__QA9Rv"};